// export const DEV_DOMAIN_URL_LOGIN = 'http://18.220.69.51:8080/backend';
// export const DEV_DOMAIN_URL_LOGIN = 'http://localhost:3000/backend';
// export const DEV_DOMAIN_URL_LOGIN = 'https://devdashboardapi.telosair.com/backend';
export const DEV_DOMAIN_URL_LOGIN = process.env.REACT_APP_DOMAIN_URL;
// export const DEV_DOMAIN_URL = 'http://18.220.215.181:8086/backend/api/v1';
export const DEV_DOMAIN_URL = `${DEV_DOMAIN_URL_LOGIN}/api/v1`;
export const DEV_NEW_DOMAIN_URL = `${DEV_DOMAIN_URL_LOGIN}/api/v2`;
export const DEV_S3_DOMAIN_URL = `${DEV_DOMAIN_URL_LOGIN}/api/s3`;
// ANDROID = /Users/akmmoru / Library / Android / sdk;
